import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json',
  },
});

apiClient.interceptors.request.use(config => {
  if (apiClient.defaults.headers.common.Authorization !== axios.defaults.headers.common.Authorization) {
    apiClient.defaults.headers.common.Authorization = axios.defaults.headers.common.Authorization;
  }
  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = axios.defaults.headers.common.Authorization;
  return config;
}, error => Promise.reject(error));

export default {
  updateCompany(id, body) {
    const result = new Promise((resolve, reject) => {
      apiClient.patch(`/companies/${id}/update`, body)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
    return result;
  },
  addCompany(body) {
    const result = new Promise((resolve, reject) => {
      apiClient.post('/companies', body)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
    return result;
  },
  deleteCompany(id) {
    const result = new Promise((resolve, reject) => {
      apiClient.delete(`/companies/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
    return result;
  },
};
